import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseRouteRenderContext } from "abreact/incubator/ui/app/router/routeRenderContext/BaseRouteRenderContext";
export class PrimaryRouteRenderContext extends BaseRouteRenderContext {
  /**
   * 'mainArea' route render context that interacts with the browser url.  It is a singleton,
   * and can be used before the router has been started.
   *
   * Warning: do not call in global (including static) scope as can cause cyclic dependencies,
   * see ABSDK-5821.
   */
  static get SINGLETON() {
    // Lazily create on first usage, and not in this module's global loading scope
    if (!PrimaryRouteRenderContext._SINGLETON) {
      PrimaryRouteRenderContext._SINGLETON = new PrimaryRouteRenderContext();
    }
    return PrimaryRouteRenderContext._SINGLETON;
  }
  static resetStatics() {
    // No-op: AbRouteRender has const ReactRouteRenderContext that uses PrimaryRouteRenderContext.
    // If the singleton instance ever changed, the above ReactRouteRenderContext would be out of sync.
    // NO need to change, as PrimaryRouteRenderContext is effectively stateless, as it accesses
    // NavigationService via always calling NavigationService.getSingleton() (but not in constructor!)
    // LOG.debug("Calling resetStatics");
    // PrimaryRouteRenderContext.SINGLETON_ = new PrimaryRouteRenderContext();
  }

  // Note that the singleton instance class MIGHT need to be modified by nav service at nav service startup.
  // Can NOT create a new instance, as AbRouteRender::RouteRenderContextContext depends on singleton instance
  constructor() {
    //vDo NOT pass in NavigationService.getSingleton() as an arg, as get cyclic deps.
    // Instead, BaseRouteRenderContext methods lazily use it, which happen after the
    // NavigationService has been initialized.
    super("PrimaryRouteRenderContext for mainArea");
  }
}
_defineProperty(PrimaryRouteRenderContext, "_SINGLETON", undefined);
//# sourceMappingURL=PrimaryRouteRenderContext.js.map
